<div class="row">
  <div class="container">
    <div class="col-md-12 overview mt-4">
      <div class="d-sm-flex align-items-center justify-content-between">
        <h2 class="h3 mb-0"> Visão geral do projeto </h2>
        <div class="d-flex card-info subtitle">
          <span *ngFor="let btn of btns_status" class="{{btn.className}}"> {{btn.value}}</span>
        </div>
      </div>

      <div class="row align-items-start mt-lg-5 mt-3">
        <div *ngFor="let card of cards; let i = index" class="col {{card.className}}">
          <div class="card-deck">
            <div class="card">
              <div class="card-block text-center">
                <h2 class="text-blue mt-4"><i class="fas {{card.icon}} fa-3x"></i></h2>
                <h5 class="card-title">{{card.title}}</h5>
              </div>
              <div class="card-body">
                <form>
                  <div class="form-check" *ngFor="let checkbox of card.checkboxes; let j = index">
                    <mat-checkbox [ngClass]="checkbox.status" checked="true" disabled>
                      <label class="form-check-label"
                        [ngClass]="checkbox.status.length > 0 && 'form-check-label-'+checkbox.status"
                        for="exampleCheck{{i}}{{j}}">{{ checkbox.label }}</label>
                    </mat-checkbox>
                  </div>
                </form>
                <app-circular-progress-bar [percentage]="progress[i]"></app-circular-progress-bar>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>